import React from "react";
import * as Constants from "../../../_constants/accessoryfinder.constants";
import AccessoriesResult from "./AccessoriesResult/AccessoriesResult";
import VacuumModelResult from "./VacuumModelResult/VacuumModelResult";
import Message from "./Message/Message";

const ResultView = (props) => {
  const pageSize = 5;
  if (props.resultType === Constants.ACCESSORIES) {
    if (props.AccessoriesDetailData.length > 0) {
      return (
        <AccessoriesResult
          data={props.AccessoriesDetailData}
          pageSize={pageSize}
        />
      );
    } else {
      return <Message title={props.title} />;
    }
  }
  if (props.resultType === Constants.VACUUMMODEL) {
    if (props.ProductDetailData.length > 0) {
      return (
        <VacuumModelResult data={props.ProductDetailData} pageSize={pageSize} />
      );
    } else {
      return <Message title={props.title} />;
    }
  }
  return null;
};
export default ResultView;
